import React, { useCallback } from 'react'
import { MyIcon } from '~/components/ui/MyIcon'
import { useRouter } from 'next/router'
import { StyledItemContent } from './RankStyle'
import FollowBtn from '../../business/FollowBtn'
import { getArtTradeRank_copyrightStatisticsModule_creatorsList_edges_node } from '~/graphqls/types/getArtTradeRank'
import { CreatorAvatar } from '~/components/business/CreatorAvatar'

export const CreatorsList: React.FC<{
  data: getArtTradeRank_copyrightStatisticsModule_creatorsList_edges_node[]
  onChange?: (param: boolean) => void
}> = ({ data, onChange }) => {
  const router = useRouter()
  const type = router.asPath.split('/')?.[2]
  const handleLink = useCallback(id => {
    if (id) {
      router.push(`/user/${id}`)
    }
  }, [])
  return (
    <StyledItemContent>
      {data.map((item, index: number) => (
        <div
          className="rank-list-item"
          key={`${item.base?.uid}_${index}`}
          onClick={() => handleLink(item?.uid)}
        >
          <div className="left">
            <div>
              {index <= 2 ? (
                <img
                  src={`/images/rank/medal_${index + 1}.png`}
                  alt=""
                  className="rank-icon"
                  width={48}
                  height={48}
                />
              ) : (
                <div
                  className="flex"
                  style={{
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: 48,
                    width: 48,
                  }}
                >
                  <div className="rank-sort">{index + 1}</div>
                </div>
              )}
            </div>
            <div className="relative creator">
              <CreatorAvatar
                image={item.base?.avatarUrl || ''}
                size={128}
                iconClassName="h-[30px] right-[3px] max-w-[45px]"
                userRole={item.base?.userRoleInfo}
                style={{ margin: '0 12px' }}
              />
            </div>
          </div>
          <div className="middle">
            <div className="title">
              <div className="text line-one">{item?.base?.nickname}</div>
            </div>
            <div className={`info`}>
              <div className="flex creators">
                {item?.social?.fansCount ? (
                  <div style={{ marginRight: 17 }}>
                    <MyIcon icon="user" className="icon" />{' '}
                    {item?.social?.fansCount || 0}
                  </div>
                ) : null}
                {item?.artworkStatistics?.artworkCount ? (
                  <div>
                    <MyIcon icon="archive" className="icon" />{' '}
                    {item?.artworkStatistics?.artworkCount || 0}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
          <div className="right" onClick={e => e.stopPropagation()}>
            <FollowBtn
              status={item?.social?.followStatus}
              targetId={item?.base?.uid}
            />
          </div>
        </div>
      ))}
    </StyledItemContent>
  )
}
